import React, { useEffect, useState } from 'react';
import YourImage from "../Assest/amit-satpute.jpg"; 

const CoachIntroSection2 = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <div
      style={{
        background: "linear-gradient(180deg, #020202 59%)",
        padding: "60px 20px",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "Outfit, sans-serif",
        color: "white",
        textAlign: "center",
      }}
    >

      {/* Left Side Image */}
      <div style={{ flex: "1 1 350px", maxWidth: "400px", margin: "20px" }}>
        <img
          src={YourImage}
          alt="Coach"
          style={{
            width: "100%",
            borderRadius: "1px",
            objectFit: "cover",
          }}
        />
      </div>

      {/* Right Side Text */}
      <div
        style={{
          flex: "1 1 400px",
          maxWidth: "600px",
          textAlign: "center",
          margin: "20px",
        }}
      >
        <h2 style={{ fontSize: "28px", fontWeight: "700", color: "#fff" }}>
          AMIT SATPUTE 
        </h2>
        <h3 style={{ fontSize: "20px", fontWeight: "600", marginTop: "10px" }}>
          FOUNDER MEMBER AND CHAIRMAN
        </h3>

        {/* Green underline */}
        <div
          style={{
            width: "60px",
            height: "4px",
            backgroundColor: "#2ecc71",
            margin: "20px auto",
            borderRadius: "4px",
          }}
        />

        <p style={{
          fontSize: "18px",
          lineHeight: "1.4",
          fontWeight: 500,
          textAlign: 'left',
          marginLeft:'10%'
        }}>
          With Over 25 Years of Experience in Credit Management and Debt Recovery, I Specialize in Financial Operations, Data 
          Analysis, and Strategic Execution. I Drive Performance Through Data-Driven Insights, Solve Operational 
          Challenges Efficiently, and Ensure Financial Oversight for Profitability. I Actively Build Partnerships With Financial 
          Institutions and Maintain Full Compliance With Banking and Regulatory Guidelines. My Leadership Ensures 
          Efficient, Ethical Recovery Processes Aligned With Industry Standards, Strengthening The Company’s Credibility and Long
          Term Success in The Finance and Recovery Sector.  
        </p>
      </div>
    </div>
  );
};

export default CoachIntroSection2;
